var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          attrs: {
            value: _vm.unique,
            filterable: _vm.filterable || _vm.allowCreate,
            "allow-create": _vm.allowCreate
          }
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.new$listeners
    ),
    [
      !!_vm.selectedOption
        ? _c("el-option", {
            key: -1,
            attrs: {
              label: _vm.selectedOption[_vm.labelField] || " ",
              value: _vm.selectedOption[_vm.uniqueField]
            }
          })
        : _vm._e(),
      _vm._l(_vm.otherOptions, function(item, index) {
        return _c("el-option", {
          key: index,
          attrs: {
            label: item[_vm.labelField] || " ",
            value: item[_vm.uniqueField]
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }